module.exports = __webpack_public_path__ + "img/stockGoodsImage.bda5fdd0.svg";